import { PageConfig } from "../page-configs";
import { AlertId, getAlert } from "../alert";
import { DISCLAIMER } from "../../../global/variables";
import { getWelcomeText } from "../welcome";
import { KUG_BUTTONS } from "../../feature-buttons";

export const pageConfigKurzarbeitergeld: PageConfig = {
    header: "Digitaler Assistent",
    alert: getAlert(AlertId.CalculateKurzarbeitergeldOrAskQuestions),
    welcome: {
        text: getWelcomeText("KUG"),
        disclaimer: DISCLAIMER,
        buttons: KUG_BUTTONS,
    },
};
